import React, { useState, useEffect } from 'react'
import moment from 'moment-timezone'

export function useTimeNow() {
	const [timeNow, setTimeNow] = useState(
		moment().tz('Asia/Taskent').format('YYYY-MM-DD HH:mm:ss'),
	)

	useEffect(() => {
		const interval = setInterval(() => {
			setTimeNow(
				moment().tz('Asia/Taskent').format('YYYY-MM-DD HH:mm:ss'),
			)
		}, 1000)
		return () => clearInterval(interval)
	}, [])

	return { timeNow }
}
